export const GENERAL_COMPETENCY_STATUSES = {
  APPROVED: 'Approved',
  PENDING_REVIEW: 'PendingReview',
  REJECTED: 'Rejected'
};

export const getGeneralCompetencyStatusThemeColor = (statusCode) => {
  switch (statusCode) {
    case GENERAL_COMPETENCY_STATUSES.APPROVED: return 'success';
    case GENERAL_COMPETENCY_STATUSES.PENDING_REVIEW: return 'warning';
    case GENERAL_COMPETENCY_STATUSES.REJECTED: return 'error';
    default: return 'inverse';
  }
};
